import React from 'react';
import { theme } from '@/styles/theme';
import {
  Edit,
  Delete,
  RestoreFromTrash,
  ManageSearch,
} from '@mui/icons-material';
import { Stack, Tooltip, IconButton } from '@mui/material';
import { Can } from '@/components/common';

interface IProductsTableActionsProps {
  id: string;
  deletedAt?: string;
  // eslint-disable-next-line no-unused-vars
  onEditProduct: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onStockLogProduct: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onDeleteProduct: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onRestoreProduct: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onEditProductMouseEnter: (id: string) => void;
}

export function ProductsTableActions({
  id,
  deletedAt,
  onEditProduct,
  onStockLogProduct,
  onDeleteProduct,
  onRestoreProduct,
  onEditProductMouseEnter,
}: IProductsTableActionsProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
    >
      <Can permissions={['products_update']}>
        <Tooltip title="Alterar" disableInteractive>
          <IconButton
            onMouseEnter={() => onEditProductMouseEnter(id)}
            onClick={() => onEditProduct(id)}
            size="small"
            sx={{
              '&:hover': {
                color: theme.palette.primary.main,
              },
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Tooltip>
      </Can>
      <Can permissions={['products_stock_log']}>
        <Tooltip title="Movimentações de estoque" disableInteractive>
          <IconButton
            onMouseEnter={() => onEditProductMouseEnter(id)}
            onClick={() => onStockLogProduct(id)}
            size="small"
            sx={{
              '&:hover': {
                color: theme.palette.primary.main,
              },
            }}
          >
            <ManageSearch fontSize="small" />
          </IconButton>
        </Tooltip>
      </Can>
      {deletedAt ? (
        <Can permissions={['products_restore']}>
          <Tooltip title="Restaurar" disableInteractive>
            <IconButton
              onClick={() => onRestoreProduct(id)}
              size="small"
              sx={{
                '&:hover': {
                  color: theme.palette.primary.main,
                },
              }}
            >
              <RestoreFromTrash fontSize="small" />
            </IconButton>
          </Tooltip>
        </Can>
      ) : (
        <Can permissions={['products_delete']}>
          <Tooltip title="Excluir" disableInteractive>
            <IconButton
              onClick={() => onDeleteProduct(id)}
              size="small"
              sx={{
                '&:hover': {
                  color: theme.palette.error.main,
                },
              }}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </Can>
      )}
    </Stack>
  );
}
